import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { DatePickerProps } from 'antd';

export const generate = (
  props?: Partial<IFormFieldSchema<DatePickerProps>>
): IFormFieldSchema<DatePickerProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Date Picker',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormDatePicker,
    'x-validator': [],
    'x-component-props': {
      placeholder: props?.['x-component-props']?.placeholder,
      allowClear: props?.['x-component-props']?.allowClear ?? true,
      size: props?.['x-component-props']?.size,
      disabled: props?.['x-component-props']?.disabled,
      picker: props?.['x-component-props']?.picker ?? 'date',
      format: props?.['x-component-props']?.format,
      showTime: props?.['x-component-props']?.showTime,
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    'x-decorator-props': {},
    'x-decorator-props-config': {},
  };
};
